<template>
	<div class="pay-det">
		<el-card class="cartbox" shadow="never">
			<div slot="header">
				<h3>订单信息</h3>
			</div>
			<div style="width: 100%">
				<div class="flexBetween order-top">
					<div class="order-msg">
						<div class="order-info flex">
							<p style="margin-right: 20px">订单号：{{ $route.query.orderId }}</p>
							<p>下单时间：{{ orderBasic.createTime }}</p>
						</div>
						<h4>{{ formatterStatus(orderBasic.tradeStatus, orderBasic.payStatus) }}</h4>

						<div v-if="orderBasic.payType !== null && orderBasic.tradeStatus != 4" class="logistics-info flex" style="margin-top: 10px; align-items: center">
							<p class="logistics-no" style="margin: 0">支付方式：{{ formatterPayType(orderBasic.payType) }}</p>
							<!-- <el-link v-if="orderBasic.payType === 2" style="margin-left: 10px" type="primary" @click="showPayInfo(orderBasic)">查看凭证</el-link> -->
							<el-link v-if="orderBasic.payStatus === 3" style="margin-left: 10px" type="primary" @click="showRemark(orderBasic)">查看审核原因</el-link>
						</div>

						<div class="logistics-info flex" style="margin-top: 10px; align-items: center" v-if="orderBasic.tradeStatus > 0 && orderBasic.tradeStatus != 4 && orderBasic.tradeStatus != 8">
							<p>发票状态：{{ formatterInvoiceStatus(invoiceInfo.invoiceStatus) }}</p>
							<div v-if="invoiceInfo !== null" class="flexStart">
								<el-link v-if="invoiceInfo.invoiceStatus === 0" style="margin-left: 10px" type="primary" @click="handleInvoice">查看开票信息</el-link>
								<el-link v-if="invoiceInfo.invoiceStatus !== 0 && invoiceInfo.invoiceStatus !== 1" style="margin-left: 10px" type="primary" @click="handleApplyInvoice">申请开票</el-link>
								<el-link v-if="invoiceInfo.invoiceStatus === 1 && invoiceInfo.invoiceInfo" style="margin-left: 10px" type="primary" @click="handleDownloadInvoice(invoiceInfo.invoiceInfo)"
									>下载发票(PDF)</el-link
								>
								<el-link v-if="invoiceInfo.invoiceStatus === 1 && invoiceInfo.invoiceXML" style="margin-left: 10px" type="primary" @click="handleDownloadInvoice(invoiceInfo.invoiceXML)"
									>下载发票(XML)</el-link
								>
								<el-link v-if="invoiceInfo.invoiceStatus === 1 && invoiceInfo.invoiceOFD" style="margin-left: 10px" type="primary" @click="handleDownloadInvoice(invoiceInfo.invoiceOFD)"
									>下载发票(OFD)</el-link
								>
								<span class="flexStart" v-if="invoiceInfo.invoiceStatus === 1" style="margin-left: 10px; color: #999999; font-size: 13px">更换发票请与客服联系</span>
							</div>
						</div>

						<el-button v-if="orderBasic.tradeStatus === 0 && orderBasic.payStatus != 1" plain size="small" style="margin-top: 20px" type="primary" @click="handlePay">去付款</el-button>
						<el-button v-if="orderBasic.tradeStatus === 0 && orderBasic.payStatus != 1" plain size="small" style="margin-top: 20px" type="primary" @click="handleChangePay">更换支付方式</el-button>
						<div v-if="orderBasic.tradeStatus === 2 || (orderBasic.tradeStatus === 3 && orderBasic.logisticsName)">
							<!-- 展示物流信息 -->
							<div class="order-info flexStart">
								<p style="margin-right: 20px">{{ orderBasic.logisticsName }}</p>
								<p>快递单号：{{ orderBasic.logisticsNo }}</p>
								<i class="el-icon-document-copy" title="复制" style="cursor: pointer; margin-left: 8px" @click="copyLogisticsNo"></i>
								<el-link v-if="orderBasic.tradeStatus === 2" style="margin-left: 10px" type="primary" @click="handleConfirm">确定收货</el-link>
								<!-- <el-button size="small" plain type="primary" @click="copyLogisticsNo">复制</el-button> -->
							</div>
						</div>
					</div>
					<div>
						<h4>
							<span style="color: #666; font-size: 12px">订单金额：</span
							><span style="color: #ff5722; font-size: 20px; font-weight: 600">{{ (orderBasic.totalAmount + orderBasic.freightAmount).toFixed(2) }} 元</span>
							<p v-if="orderBasic.freightAmount > 0" style="color: #666; font-size: 14px; font-weight: normal; margin-top: 10px">包括{{ orderBasic.freightAmount }}元运费</p>
						</h4>
					</div>
				</div>
				<div>
					<!-- <el-timeline class="timeline">
						<el-timeline-item class="lineitem" :color="activity.color" v-for="(activity, index) in activities" :key="index" :timestamp="activity.time">
							<span style="display: flex; flex-direction: column">
								<span style="margin: 10px 0; font-size: 14px">
									{{ activity.content }}
								</span>
								<span style="color: #8c8c8c; font-size: 12px">
									{{ activity.timestamp }}
								</span>
							</span>
						</el-timeline-item>
					</el-timeline> -->
				</div>
			</div>
		</el-card>
		<DialogShowPayInfo ref="DialogShowPayInfoRef" :corporateInfoUrl="corporateInfoUrl"></DialogShowPayInfo>
		<!--    支付-->
		<Pay
			ref="PayRef"
			:tradeComment="orderBasic.tradeComment"
			:orderNum="orderBasic.tradeNo"
			:total="orderBasic.totalAmount + orderBasic.freightAmount"
			:freightAmount="orderBasic.freightAmount"
			@successPay="successPay"
		></Pay>
		<!-- 发票信息 -->
		<DialogInvoiceInfo ref="dialogInvoiceInfo" :form="invoiceInfo"></DialogInvoiceInfo>
		<!-- 申请开票 -->
		<DialogApplyInvoice ref="dialogApplyInvoice" :tradeNo="$route.query.orderId" @confirm="successInvoice"></DialogApplyInvoice>
		<!-- 更换支付方式 -->
		<DialogChangePayType ref="dialogChangePayType" :noOfflineTransfer="noOfflineTransfer" @changePayType="changePayType" :tradeNo="$route.query.orderId"></DialogChangePayType>
	</div>
</template>

<script>
	import Pay from '@/components/Pay/index.vue';
	import CopyText from '@/utils/CopyText';
	import DialogShowPayInfo from '@/views/UserCenter/components/DialogShowPayInfo.vue';
	import DialogInvoiceInfo from '@/views/UserCenter/components/DialogInvoiceInfo.vue';
	import User from '@/utils/User.js';
	import DialogApplyInvoice from '@/views/UserCenter/components/DialogApplyInvoice.vue';
	import { getConsumerOrderReceipt, getConsumerOrderInfo } from '@/api/order/order.js';
	import DialogChangePayType from '@/views/UserCenter/components/DialogChangePayType.vue';
	import Y from '@/utils/Y.js';
	import TLoading from '@/utils/TLoading.js';
	export default {
		name: 'PayDet',
		props: {
			orderAddress: {
				type: Object,
				required: true
			},
			orderBasic: {
				type: Object,
				required: true
			},
			orderDetails: {
				type: Array,
				required: true
			},
			invoiceInfo: {
				type: Object,
				required: true
			}
		},
		components: {
			Pay,
			DialogShowPayInfo,
			DialogInvoiceInfo,
			DialogApplyInvoice,
			DialogChangePayType
		},
		data() {
			return {
				loadingInstance: null,
				corporateInfoUrl: '',
				radio: 1,
				// noOfflineTransfer: false,
				activities: [
					{
						content: '提交订单',
						timestamp: '2018-04-15',
						active: true
					},
					{
						content: '付款成功',
						timestamp: '2018-04-13',
						active: true
					},
					{
						content: '商品出库',
						timestamp: '2018-04-11',
						active: true
					},
					{
						content: '等待收货',
						timestamp: '2018-04-11',
						active: true
					},
					{
						content: '完成交易',
						timestamp: '2018-04-11',
						active: true
					}
				]
			};
		},
		methods: {
			changePayType(val) {
				// console.log('val', val);
				const { tradeNo, payType } = val;
				if (payType == 0) {
					this.$router.push({ path: '/WeChatPay', query: { orderId: tradeNo } });
				} else if (payType == 1) {
					this.$router.push({ path: '/AlipayPay', query: { orderId: tradeNo } });
				} else if (payType == 2) {
					this.$router.push({ path: '/OfflineTransfer', query: { orderId: tradeNo } });
				}
			},
			handleConfirm() {
				Y.confirm('请确保您已收到并验收商品，确认后，本单交易完成！').then(rlt => {
					if (rlt.confirm) {
						this.getConsumerOrderReceipt();
					}
				});
			},

			//确认收货
			async getConsumerOrderReceipt() {
				await getConsumerOrderReceipt(this.orderBasic.tradeNo)
					.then(res => {
						this.$emit('successPay');
						Y.msg.success('订单确认收货成功！');
					})
					.catch(err => {
						Y.msg.error(err.message || '订单确认收货失败');
					});
			},

			handleApplyInvoice() {
				this.$refs.dialogApplyInvoice.dialogVisible = true;
			},
			async handleDownloadInvoice(fileInfo) {
				this.loadingInstance = TLoading.startBgWhite({ text: '发票文件准备中，请耐心等待 \n 若长时间未启动下载，请刷新页面后重试' });
				try {
					const response = await fetch(`/webL_api/third/files/info/${fileInfo}`, {
						headers: {
							Authorization: 'Bearer ' + User.getToken(),
							'corporate-id': User.getCorporate().corporateId
						}
					});
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}

					const arrayBuffer = await response.arrayBuffer();

					// 通过文件头魔数检测真实文件类型（避免Content-Type不准确）
					const detected = this.detectFileType(arrayBuffer);
					const realMime = detected ? detected.mime : response.headers.get('Content-Type') || 'application/octet-stream';

					// 优先从Content-Disposition获取文件名
					let fileName = `${this.orderBasic.tradeNo}`;

					const blob = new Blob([arrayBuffer], { type: realMime });

					// 下载文件
					this.downloadFile(blob, fileName);
				} catch (error) {
					console.error('获取发票失败:', error);
					this.$message.error('发票下载失败');
					return null;
				}
			},

			// 通过文件头魔数检测真实文件类型
			detectFileType(arrayBuffer) {
				const arr = new Uint8Array(arrayBuffer);
				if (arr.length < 4) return null;

				// RAR: 52 61 72 21 1A 07 (Rar!␚␇)
				if (arr.length >= 7 && arr[0] === 0x52 && arr[1] === 0x61 && arr[2] === 0x72 && arr[3] === 0x21 && arr[4] === 0x1a && arr[5] === 0x07) {
					return { ext: 'rar', mime: 'application/vnd.rar' };
				}
				// ZIP 系（zip / xlsx / docx）：50 4B 03 04
				if (arr[0] === 0x50 && arr[1] === 0x4b && arr[2] === 0x03 && arr[3] === 0x04) {
					// 在ZIP二进制中搜索特征路径区分 docx / xlsx / 纯zip
					// docx 内包含 "word/" 路径，xlsx 内包含 "xl/" 路径
					const searchBytes = pattern => {
						const bytes = new TextEncoder().encode(pattern);
						for (let i = 0; i <= arr.length - bytes.length; i++) {
							let match = true;
							for (let j = 0; j < bytes.length; j++) {
								if (arr[i + j] !== bytes[j]) {
									match = false;
									break;
								}
							}
							if (match) return true;
						}
						return false;
					};
					if (searchBytes('word/')) {
						return { ext: 'docx', mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' };
					}
					if (searchBytes('xl/')) {
						return { ext: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
					}
					// 非 Office 格式，返回纯 ZIP
					return { ext: 'zip', mime: 'application/zip' };
				}
				// PDF: %PDF
				if (arr[0] === 0x25 && arr[1] === 0x50 && arr[2] === 0x44 && arr[3] === 0x46) {
					return { ext: 'pdf', mime: 'application/pdf' };
				}
				// JPEG: FF D8 FF
				if (arr[0] === 0xff && arr[1] === 0xd8 && arr[2] === 0xff) {
					return { ext: 'jpg', mime: 'image/jpeg' };
				}
				// PNG: 89 50 4E 47
				if (arr[0] === 0x89 && arr[1] === 0x50 && arr[2] === 0x4e && arr[3] === 0x47) {
					return { ext: 'png', mime: 'image/png' };
				}
				// GIF: 47 49 46 38
				if (arr[0] === 0x47 && arr[1] === 0x49 && arr[2] === 0x46 && arr[3] === 0x38) {
					return { ext: 'gif', mime: 'image/gif' };
				}
				// WebP: 52 49 46 46 ... 57 45 42 50
				if (arr[0] === 0x52 && arr[1] === 0x49 && arr[2] === 0x46 && arr[3] === 0x46 && arr.length >= 12 && arr[8] === 0x57 && arr[9] === 0x45 && arr[10] === 0x42 && arr[11] === 0x50) {
					return { ext: 'webp', mime: 'image/webp' };
				}
				// BMP: 42 4D
				if (arr[0] === 0x42 && arr[1] === 0x4d) {
					return { ext: 'bmp', mime: 'image/bmp' };
				}
				// OLE2 系（doc / xls）：D0 CF 11 E0
				if (arr[0] === 0xd0 && arr[1] === 0xcf && arr[2] === 0x11 && arr[3] === 0xe0) {
					return { ext: 'doc', mime: 'application/msword' };
				}
				return null;
			},

			// 通用文件下载方法
			downloadFile(blob, filename) {
				const url = URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = filename;
				link.style.display = 'none';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url); // 释放内存
				// 显示下载成功提示
				this.$message.success('发票下载成功！');
				TLoading.close(this.loadingInstance);
			},

			handleInvoice() {
				this.$refs.dialogInvoiceInfo.dialogVisible = true;
			},
			formatterInvoiceStatus(invoiceStatus) {
				return invoiceStatus === 0 ? '开票中' : invoiceStatus === 1 ? '已开票' : '未开票';
			},
			showRemark(orderBasic) {
				let remark = orderBasic.remark ? '支付凭证信息审核未通过原因：' + orderBasic.remark : '支付凭证信息审核未通过原因：未填写，具体请联系客服！';
				this.$confirm(remark, '提示', {
					showConfirmButton: false,
					cancelButtonText: '关闭',
					type: 'warning'
				})
					.then(() => {})
					.catch(() => {});
			},

			async showPayInfo(info) {
				try {
					const response = await fetch(`/webL_api/third/files/info/${info.paymentVoucher}`, {
						headers: {
							Authorization: 'Bearer ' + User.getToken()
						}
					});
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					const arrayBuffer = await response.arrayBuffer();
					const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
					const imageUrlData = URL.createObjectURL(blob);
					this.corporateInfoUrl = imageUrlData;
					this.$refs.DialogShowPayInfoRef.dialogVisible = true;
				} catch (error) {
					console.error('获取图片失败:', error);
					return null;
				}
			},

			formatterPayType(payType) {
				if (payType === null) {
					return '';
				} else {
					return payType == 0 ? '微信支付' : payType == 1 ? '支付宝支付' : '对公转账';
				}
			},

			copyLogisticsNo() {
				// 复制物流单号到剪贴板
				CopyText.copyMessage(this.orderBasic.logisticsNo);
			},

			handlePay() {
				getConsumerOrderInfo(this.orderBasic.tradeNo).then(res => {
					if (res.code == 200) {
						//查询订单状态
						if (res.data.orderBasic.tradeStatus == 0) {
							if (this.orderBasic.payType == 0) {
								this.$router.push({ path: '/WeChatPay', query: { orderId: this.orderBasic.tradeNo } });
							} else if (this.orderBasic.payType == 1) {
								this.$router.push({ path: '/AlipayPay', query: { orderId: this.orderBasic.tradeNo } });
							} else if (this.orderBasic.payType == 2) {
								this.$router.push({ path: '/OfflineTransfer', query: { orderId: this.orderBasic.tradeNo } });
							}
						} else {
							TMessage.warning('订单已支付或已取消');
						}
					}
				});
			},

			handleChangePay() {
				// this.curOrderNo = tradeNo;
				this.$refs.dialogChangePayType.dialogVisible = true;
			},

			successPay() {
				this.$emit('successPay');
			},

			successInvoice() {
				this.$emit('successInvoice');
			},

			formatterStatus(tradeStatus, payStatus) {
				let statusText = '';
				switch (tradeStatus) {
					case 0:
						statusText = '待支付';
						if (payStatus === 1) {
							statusText = '凭证审核中';
						}
						if (payStatus === 3) {
							statusText = '凭证审核不通过';
						}
						break;
					case 1:
						// statusText = '已支付';
						statusText = '待发货';
						break;
					case 2:
						statusText = '已发货';
						break;
					case 3:
						statusText = '已完成';
						break;
					case 4:
						statusText = '已取消';
						break;
					case 5:
						statusText = '退款中';
						break;
					case 6:
						statusText = '已退款';
						break;
					case 8:
						statusText = '待审核';
						break;
					default:
						statusText = '未知状态';
				}
				return statusText;
			}
		},
		computed: {
			noOfflineTransfer() {
				//this.orderBasic.tradeNo 包括VIP 返回false
				if (this.orderBasic.tradeNo.indexOf('VIP') != -1) {
					return false;
				} else {
					return true;
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.timeline {
		display: flex;
		width: 100%;
		margin-bottom: 80px;
		margin-top: 40px;

		.lineitem {
			transform: translateX(50%);
			width: 25%;
		}
	}

	::v-deep .el-timeline-item__tail {
		border-left: none;
		border-top: 2px solid #e4e7ed;
		width: 100%;
		position: absolute;
		top: 6px;
	}

	::v-deep .el-timeline-item__wrapper {
		padding-left: 0;
		position: absolute;
		top: 20px;
		transform: translateX(-50%);
		text-align: center;
	}

	::v-deep .el-timeline-item__timestamp {
		font-size: 14px;
	}

	.pay-det {
		margin-bottom: 20px;
		background-color: #ffffff;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 15px;
		.pay-type {
			margin-top: 20px;
			display: flex;
			align-items: center;

			em {
				font-style: normal;
				font-weight: 400;
			}
		}
		h3 {
			margin: 0;
			font-weight: 400;
			font-size: 18px;
			color: #333333;
		}

		h4 {
			color: #ff5722;
			font-size: 20px;
			font-weight: 600;
			margin-top: 18px;
		}

		.order-top {
			width: 100%;
			margin-bottom: 20px;
			// border-bottom: 1px solid #e6e6e6;
			padding-bottom: 20px;
			align-items: baseline;
		}

		.order-msg {
			flex: 1;
			color: #333;
			font-size: 14px;

			> p {
				line-height: 22px;
				color: #666;
				font-size: 12px;
			}
		}

		.order-info {
			margin-bottom: 10px;
		}

		h4 {
			margin: 0;
		}

		.address-info {
			p {
				display: inline-block;
				line-height: 22px;
				color: #666;
				font-size: 12px;
			}
		}

		.goods-info {
			p {
				display: inline-block;
				line-height: 22px;
				color: #666;
				font-size: 12px;
			}
		}
	}
</style>
